// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__AYHj5","footer":"ModalError_footer__1I4Lg"};